import { render, staticRenderFns } from "./TShirts.vue?vue&type=template&id=0f107291&scoped=true&"
import script from "./TShirts.vue?vue&type=script&lang=js&"
export * from "./TShirts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f107291",
  null
  
)

export default component.exports